import { render, staticRenderFns } from "./editVideoManagement.vue?vue&type=template&id=4c61df6d&"
import script from "./editVideoManagement.vue?vue&type=script&lang=js&"
export * from "./editVideoManagement.vue?vue&type=script&lang=js&"
import style0 from "./editVideoManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports